require('./dist/ng-openseadragon.min');
module.exports = 'ngOpenseadragon';



//////////////////
// WEBPACK FOOTER
// ./~/ng-openseadragon/index.js
// module id = 60
// module chunks = 2